import React from "react";
import "./JoinOurMission.css";

const JoinOurMission = () => {
  return (
    <section className="join-mission-section">
      <div className="join-mission-container">
        <h2 className="join-heading">Join the MBR Network’s Revolution 🚀</h2>
        <p className="join-subtext">
          Step into a movement that’s redefining how careers are built. At{" "}
          <span className="highlight">MBR Network’s</span>, we believe success
          grows faster when shared — that’s why we’re uniting students, mentors,
          and industry professionals under one vision. Whether you’re a{" "}
          <strong>fresher chasing your first break</strong> or a{" "}
          <strong>professional eager to uplift others</strong>, there’s a seat
          waiting for you in our family. Let’s shape careers, inspire growth,
          and build a generation that lifts each other up. 🌍✨
        </p>

        <div className="join-buttons">
          <a
            href="https://www.linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="join-btn linkedin"
          >
            Join Our LinkedIn Network
          </a>
          <a href="#contact" className="join-btn guidance">
            Get Career Guidance
          </a>
        </div>

        <div className="animated-bg"></div>
      </div>
    </section>
  );
};

export default JoinOurMission;
